import { ChevronRight } from "lucide-react";
import * as React from "react";

import { PaginationLink } from "@/components/pagination/PaginationLink";
import { NormalText } from "@/components/text/NormalText";
import { cn } from "@/utils/cn";

export function PaginationNext({
  className,
  ...props
}: React.ComponentProps<typeof PaginationLink>) {
  return (
    <PaginationLink
      aria-label="Go to next page"
      size="default"
      className={cn("gap-1 pr-2.5", className)}
      {...props}
    >
      <NormalText elementType="span" className="hidden md:block">
        Next
      </NormalText>
      <ChevronRight className="h-4 w-4" />
    </PaginationLink>
  );
}
PaginationNext.displayName = "PaginationNext";
